import PropTypes from "prop-types";
import React from "react";

import { Heading, headingPropTypes } from "@swa-ui/core";
import { classNames } from "@swa-ui/string";

/**
 * PlacementHeading provides a consistent semantic heading placement experience that
 * combines the design system Heading core component with the expected attribute shape from WCM
 * placement response. This component is to be used across all placements that need a heading
 * based on the placement design.
 */
export const PlacementHeading = (props) => {
  // TODO: Remove color, fontSize, and fontWeight once WCM uses the new headingProps interface.
  const { className, color, fontSize, fontWeight, headingProps = {}, value } = props;

  return (
    value && (
      <Heading {...getProps()}>
        <span style={{ fontSize }}>{value}</span>
      </Heading>
    )
  );

  function getProps() {
    return {
      bold: fontWeight === "bold",
      color,
      ...headingProps,
      className: classNames(className, headingProps?.className),
    };
  }
};

export const placementHeadingPropTypes = {
  /** Additional class name provided for positioning only. */
  className: PropTypes.string,

  /** Color of the heading. Backwards compatible with WCM heading interface. */
  color: PropTypes.string,

  /** Font size of the heading. Backwards compatible with WCM heading interface. */
  fontSize: PropTypes.string,

  /** Font weight of the heading. Backwards compatible with WCM heading interface. */
  fontWeight: PropTypes.oneOf(["bold", "normal"]),

  /** Additional props to interact with the Heading core component. Look to `@swa-ui/core` Heading.js for more details. */
  headingProps: PropTypes.shape(headingPropTypes),

  /** The heading text. */
  value: PropTypes.string.isRequired,
};

PlacementHeading.displayName = "PlacementHeading";
PlacementHeading.propTypes = placementHeadingPropTypes;
